import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

// Fungsi untuk memetakan nama gear ke ikon di public/gears/ sesuai urutan daftar
const getGearIcon = (gearName) => {
  const gearIconMap = {
    "running vest/belt": "/gears/01.svg",
    "mobile phone with gpx route": "/gears/02.svg",
    smartwatch: "/gears/03.png",
    "minimum water supply of 500ml": "/gears/04.svg",
    "foldable cup": "/gears/05.svg",
    "survival blanket": "/gears/06.svg",
    "first aid kits": "/gears/07.svg",
    "snack/energy bar": "/gears/08.svg",
    "windproof jacket": "/gears/09.svg",
    "rainproof jacket/poncho": "/gears/10.svg",
    "id card": "/gears/11.svg",
    whistle: "/gears/12.svg",
    headlamp: "/gears/13.svg",
    "cap/bandana": "/gears/14.svg",
    "running shoes": "/gears/15.png",
    "sufficient cash": "/gears/16.svg",
    "trekking poles": "/gears/17.png",
  };
  return gearIconMap[gearName.toLowerCase()] || "/gears/default-gear.svg";
};

export const MandatoryGears = ({ categoryName }) => {
  const gears = {
    "Vertical (7K)": [
      { gear: "Running Vest/Belt", mandatory: false, recommended: true },
      {
        gear: "Mobile Phone with GPX Route",
        mandatory: false,
        recommended: true,
      },
      { gear: "Smartwatch", mandatory: false, recommended: true },
      {
        gear: "Minimum Water Supply of 500ml",
        mandatory: true,
        recommended: false,
      },
      { gear: "Foldable Cup", mandatory: false, recommended: true },
      { gear: "Survival Blanket", mandatory: false, recommended: true },
      { gear: "First Aid Kits", mandatory: true, recommended: false },
      { gear: "Snack/Energy Bar", mandatory: false, recommended: true },
      { gear: "Windproof Jacket", mandatory: false, recommended: true },
      { gear: "Rainproof Jacket/Poncho", mandatory: false, recommended: true },
      { gear: "ID Card", mandatory: true, recommended: false },
      { gear: "Whistle", mandatory: true, recommended: false },
      { gear: "Headlamp", mandatory: false, recommended: true },
      { gear: "Cap/Bandana", mandatory: false, recommended: true },
      { gear: "Running Shoes", mandatory: true, recommended: false },
      { gear: "Sufficient Cash", mandatory: false, recommended: true },
      { gear: "Trekking Poles", mandatory: false, recommended: true },
    ],
    "Fun Trail (7K)": [
      { gear: "Running Vest/Belt", mandatory: false, recommended: true },
      {
        gear: "Mobile Phone with GPX Route",
        mandatory: false,
        recommended: true,
      },
      { gear: "Smartwatch", mandatory: false, recommended: true },
      {
        gear: "Minimum Water Supply of 500ml",
        mandatory: true,
        recommended: false,
      },
      { gear: "Foldable Cup", mandatory: true, recommended: false },
      { gear: "Survival Blanket", mandatory: false, recommended: true },
      { gear: "First Aid Kits", mandatory: true, recommended: false },
      { gear: "Snack/Energy Bar", mandatory: false, recommended: true },
      { gear: "Windproof Jacket", mandatory: false, recommended: true },
      { gear: "Rainproof Jacket/Poncho", mandatory: false, recommended: true },
      { gear: "ID Card", mandatory: true, recommended: false },
      { gear: "Whistle", mandatory: true, recommended: false },
      { gear: "Headlamp", mandatory: false, recommended: true },
      { gear: "Cap/Bandana", mandatory: false, recommended: true },
      { gear: "Running Shoes", mandatory: true, recommended: false },
      { gear: "Sufficient Cash", mandatory: false, recommended: true },
      { gear: "Trekking Poles", mandatory: false, recommended: true },
    ],
    "Classic Distance (20K)": [
      { gear: "Running Vest/Belt", mandatory: true, recommended: false },
      {
        gear: "Mobile Phone with GPX Route",
        mandatory: true,
        recommended: false,
      },
      { gear: "Smartwatch", mandatory: false, recommended: true },
      {
        gear: "Minimum Water Supply of 500ml",
        mandatory: true,
        recommended: false,
      },
      { gear: "Foldable Cup", mandatory: true, recommended: false },
      { gear: "Survival Blanket", mandatory: true, recommended: false },
      { gear: "First Aid Kits", mandatory: true, recommended: false },
      { gear: "Snack/Energy Bar", mandatory: false, recommended: true },
      { gear: "Windproof Jacket", mandatory: false, recommended: true },
      { gear: "Rainproof Jacket/Poncho", mandatory: true, recommended: false },
      { gear: "ID Card", mandatory: true, recommended: false },
      { gear: "Whistle", mandatory: true, recommended: false },
      { gear: "Headlamp", mandatory: true, recommended: false },
      { gear: "Cap/Bandana", mandatory: false, recommended: true },
      { gear: "Running Shoes", mandatory: true, recommended: false },
      { gear: "Sufficient Cash", mandatory: false, recommended: true },
      { gear: "Trekking Poles", mandatory: false, recommended: true },
    ],
    "Short Distance (40K)": [
      { gear: "Running Vest/Belt", mandatory: true, recommended: false },
      {
        gear: "Mobile Phone with GPX Route",
        mandatory: true,
        recommended: false,
      },
      { gear: "Smartwatch", mandatory: false, recommended: true },
      {
        gear: "Minimum Water Supply of 500ml",
        mandatory: true,
        recommended: false,
      },
      { gear: "Foldable Cup", mandatory: true, recommended: false },
      { gear: "Survival Blanket", mandatory: true, recommended: false },
      { gear: "First Aid Kits", mandatory: true, recommended: false },
      { gear: "Snack/Energy Bar", mandatory: false, recommended: true },
      { gear: "Windproof Jacket", mandatory: true, recommended: false },
      { gear: "Rainproof Jacket/Poncho", mandatory: true, recommended: false },
      { gear: "ID Card", mandatory: true, recommended: false },
      { gear: "Whistle", mandatory: true, recommended: false },
      { gear: "Headlamp", mandatory: true, recommended: false },
      { gear: "Cap/Bandana", mandatory: false, recommended: true },
      { gear: "Running Shoes", mandatory: true, recommended: false },
      { gear: "Sufficient Cash", mandatory: false, recommended: true },
      { gear: "Trekking Poles", mandatory: false, recommended: true },
    ],
    "Long Distance (80 K)": [
      { gear: "Running Vest/Belt", mandatory: true, recommended: false },
      {
        gear: "Mobile Phone with GPX Route",
        mandatory: true,
        recommended: false,
      },
      { gear: "Smartwatch", mandatory: false, recommended: true },
      {
        gear: "Minimum Water Supply of 500ml",
        mandatory: true,
        recommended: false,
      },
      { gear: "Foldable Cup", mandatory: true, recommended: false },
      { gear: "Survival Blanket", mandatory: true, recommended: false },
      { gear: "First Aid Kits", mandatory: true, recommended: false },
      { gear: "Snack/Energy Bar", mandatory: false, recommended: true },
      { gear: "Windproof Jacket", mandatory: true, recommended: false },
      { gear: "Rainproof Jacket/Poncho", mandatory: true, recommended: false },
      { gear: "ID Card", mandatory: true, recommended: false },
      { gear: "Whistle", mandatory: true, recommended: false },
      { gear: "Headlamp", mandatory: true, recommended: false },
      { gear: "Cap/Bandana", mandatory: false, recommended: true },
      { gear: "Running Shoes", mandatory: true, recommended: false },
      { gear: "Sufficient Cash", mandatory: false, recommended: true },
      { gear: "Trekking Poles", mandatory: false, recommended: true },
    ],
    "Mix Group (20K)": [
      { gear: "Running Vest/Belt", mandatory: true, recommended: false },
      {
        gear: "Mobile Phone with GPX Route",
        mandatory: true,
        recommended: false,
      },
      { gear: "Smartwatch", mandatory: false, recommended: true },
      {
        gear: "Minimum Water Supply of 500ml",
        mandatory: true,
        recommended: false,
      },
      { gear: "Foldable Cup", mandatory: true, recommended: false },
      { gear: "Survival Blanket", mandatory: true, recommended: false },
      { gear: "First Aid Kits", mandatory: true, recommended: false },
      { gear: "Snack/Energy Bar", mandatory: false, recommended: true },
      { gear: "Windproof Jacket", mandatory: false, recommended: true },
      { gear: "Rainproof Jacket/Poncho", mandatory: true, recommended: false },
      { gear: "ID Card", mandatory: true, recommended: false },
      { gear: "Whistle", mandatory: true, recommended: false },
      { gear: "Headlamp", mandatory: true, recommended: false },
      { gear: "Cap/Bandana", mandatory: false, recommended: true },
      { gear: "Running Shoes", mandatory: true, recommended: false },
      { gear: "Sufficient Cash", mandatory: false, recommended: true },
      { gear: "Trekking Poles", mandatory: false, recommended: true },
    ],
  };

  const mandatoryGears = gears[categoryName];

  if (!categoryName || !mandatoryGears) {
    return (
      <div className="px-4 py-4 text-sm text-gray-700 text-center">
        Tidak ada data Mandatory Gears tersedia untuk kategori{" "}
        {categoryName || "tidak diketahui"}.
      </div>
    );
  }

  return (
    <div>
      <div className="overflow-x-auto">
        <table className="w-full table-auto divide-y divide-slate-200">
          <thead>
            <tr className="bg-gray-100 divide-x divide-slate-200">
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider w-full">
                Gears {categoryName}
              </th>
              <th className="px-4 py-3 text-center text-xs font-medium text-gray-600 uppercase tracking-wider w-20">
                Mandatory
              </th>
              <th className="px-4 py-3 text-center text-xs font-medium text-gray-600 uppercase tracking-wider w-20">
                Recommended
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200">
            {mandatoryGears.map((gear, index) => (
              <tr
                key={index}
                className="border-b border-slate-200 last:border-b-0 hover:bg-gray-50 divide-x divide-slate-200"
              >
                <td className="px-4 py-4 text-sm text-gray-700 w-full pr-12">
                  <div className="flex items-center whitespace-nowrap space-x-3">
                    <img
                      src={getGearIcon(gear.gear)}
                      alt={`${gear.gear} icon`}
                      className="w-7 h-7 object-contain"
                      onError={(e) => {
                        e.target.src = "/gears/default-gear.jpg";
                      }}
                    />
                    <span>{gear.gear || ""}</span>
                  </div>
                </td>
                <td className="px-4 py-4 text-sm text-gray-700 w-20 text-center">
                  {gear.mandatory ? (
                    <span className="inline-flex items-center justify-center w-5 h-5 bg-lime-600 text-white rounded-full">
                      <FontAwesomeIcon icon={faCheck} className="text-xs" />
                    </span>
                  ) : (
                    ""
                  )}
                </td>
                <td className="px-4 py-4 text-sm text-gray-700 w-20 text-center">
                  {gear.recommended ? (
                    <span className="inline-flex items-center justify-center w-5 h-5 bg-lime-600 text-white rounded-full">
                      <FontAwesomeIcon icon={faCheck} className="text-xs" />
                    </span>
                  ) : (
                    ""
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
